import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { MealPlan, ScaledRecipe } from '@/api/types'
import { Button } from '@/components/Button'
import { Dialog, DialogTrigger, Modal, ModalContent, ModalHeader } from '@/components/Modal'
import { getNutrientsForUser } from '../utils'
import MealDetail from './MealDetail/MealDetail'

import './WeekPlanRow.css'
import { GetReplacementsFn } from './CreateMealPlan'

type Props = {
  mealOfDay: string
  mainUserId: number
  days: Array<MealPlan | null>
  getReplacements: GetReplacementsFn
  replacedMealIds: Record<string, boolean>
}

let i = 0

export default function WeekPlanRow({
  mealOfDay,
  mainUserId,
  days,
  getReplacements,
  replacedMealIds,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="WeekPlanRow-container">
      <h5 className="WeekPlanRow-heading">{t(`mealOfDay.${mealOfDay}` as any)}</h5>
      <div className="WeekPlanRow-grid">
        {days.map((day) =>
          day ? (
            <DialogTrigger key={day.dayOfWeek + '_' + day.mealOfDay}>
              <Button
                className={classNames('WeekPlanRow-btn', {
                  'WeekPlanRow-btn--replaced': replacedMealIds[`${day.dayOfWeek}-${day.mealOfDay}`],
                })}
              >
                {replacedMealIds[`${day.dayOfWeek}-${day.mealOfDay}`] && (
                  <span className="WeekPlanRow-badge">{t('mealPlan.updatedBadge')}</span>
                )}
                <Meal scaledRecipes={day.scaledRecipes} mainUserId={mainUserId} />
              </Button>

              <Modal>
                <Dialog>
                  {({ close }) => (
                    <>
                      <ModalHeader onClose={close}>
                        Meal detail - {t(`profile.dayOfWeek.${day.dayOfWeek}`)}-{' '}
                        {t(`mealOfDay.${day.mealOfDay}` as any)}
                      </ModalHeader>

                      <ModalContent style={{ padding: 0 }}>
                        <MealDetail
                          dayPlan={day}
                          mainUserId={mainUserId}
                          getReplacements={getReplacements}
                        />
                      </ModalContent>
                    </>
                  )}
                </Dialog>
              </Modal>
            </DialogTrigger>
          ) : (
            <div key={i++}></div>
          ),
        )}
      </div>
    </div>
  )
}

type MealListProps = {
  scaledRecipes: ScaledRecipe[]
  mainUserId: number
}

function Meal({ scaledRecipes, mainUserId }: MealListProps) {
  const kcal = getNutrientsForUser(scaledRecipes, mainUserId).energy

  return (
    <div className="WeekPlanRow-meal">
      <div className="WeekPlanRow-list">
        {scaledRecipes.map((meal) => (
          <div key={meal.recipe.name}>{meal.recipe.name}</div>
        ))}
      </div>
      <div className="WeekPlanRow-kcal">{Math.round(kcal)}kcal</div>
    </div>
  )
}
